/** Persist free-form target guidance alongside the existing lesson AI context. */
const PREFIX = 'VERBASCHOLA_GUIDANCE_V1\n';
export function readTargetGuidance(value: string | null | undefined) {
    if (value?.startsWith(PREFIX)) {
        try {
            const data = JSON.parse(value.slice(PREFIX.length));
            if (typeof data.context === 'string' && typeof data.vocabulary === 'string' && typeof data.grammar === 'string') {
                return { context: data.context, vocabulary: data.vocabulary, grammar: data.grammar, source: typeof data.source === 'string' ? data.source : '' };
            }
        } catch { /* Legacy/custom guidance remains ordinary text. */ }
    }
    return { context: value ?? '', vocabulary: '', grammar: '', source: '' };
}
export function writeTargetGuidance(context: string, vocabulary: string, grammar: string): string | null {
    return vocabulary.trim() || grammar.trim()
        ? PREFIX + JSON.stringify({ context, vocabulary, grammar })
        : context.trim() || null;
}
